export default () => {
  const counters = document.querySelectorAll('.js-counter')
  if (counters.length < 1) return

  // If the browser does NOT support IntersectionObserver
  if (!('IntersectionObserver' in window)) {
    counters.forEach(counter => countUp(counter))
    return
  }

  // Observer
  let counterObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let counter = entry.target
        countUp(counter)
        counterObserver.unobserve(counter)
      }
    })
  })

  counters.forEach(counter => {
    counterObserver.observe(counter)
  })
}

function countUp(counter) {
  const nr = parseInt(counter.dataset.nr, 10) || 1
  counter.textContent = '0'

  const duration = 2000
  const step = Math.max(1, Math.ceil(nr / (duration / 10)))
  const iteration = duration / (nr / step)
  let count = 0

  const interval = window.setInterval(() => {
    count += step
    const display = count >= nr ? nr : count
    counter.textContent = display
    if (display >= nr) {
      window.clearInterval(interval)
    }
  }, iteration)
}



// WEBPACK FOOTER //
// ./src/js/modules/Counter.js